import { combineReducers } from 'redux';
import { settlements } from './settlements';

export const contracts = combineReducers({ settlements });
